import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { Copy } from "lucide-react";
import PropTypes from "prop-types";
import Button from "./Button";
import ManualCopyModal from "./ManualCopyModal";

/* global navigator, ClipboardItem, console */

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
});

async function setClipboard(text) {
  try {
    const type = "text/plain";
    const clipboardItemData = {
      [type]: text,
    };
    const clipboardItem = new ClipboardItem(clipboardItemData);
    await navigator.clipboard.write([clipboardItem]);
    return true;
  } catch (err) {
    console.error("Clipboard copy failed:", err);
    return false;
  }
}

const CopyContentButton = ({ content, onDone, children, ...props }) => {
  const [showManualCopy, setShowManualCopy] = React.useState(false);
  const styles = useStyles();

  const handleCopy = () => {
    setClipboard(content).then((success) => {
      if (success) {
        onDone();
      } else {
        setShowManualCopy(true);
      }
    });
  };

  return (
    <>
      <Button {...props} onClick={handleCopy}>
        <div className={styles.container}>
          <Copy size={16} />
          {children}
        </div>
      </Button>
      {showManualCopy && <ManualCopyModal value={content} onDone={onDone} />}
    </>
  );
};

CopyContentButton.propTypes = {
  content: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default CopyContentButton;
